/* Country / Parent OOH collection — client-side filter + sort + paginate.
   Supports any data-filter group (city, country, type) — derived from chips. */
(function () {
  var root = document.querySelector('[data-country-collection]');
  if (!root) return;

  var grid = root.querySelector('[data-grid]');
  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-card]'));
  var emptyEl = root.querySelector('[data-empty]');
  var paginationEl = root.querySelector('[data-pagination]');
  var countShownEl = root.querySelector('[data-count-shown]');
  var clearBtn = root.querySelector('[data-clear]');
  var sortSelect = root.querySelector('[data-sort]');
  var chips = Array.prototype.slice.call(root.querySelectorAll('.co-chip[data-filter]'));

  var PER_PAGE = 12;
  var state = { sort: 'featured', page: 1 };
  // derive filter keys from chips
  chips.forEach(function (chip) {
    var f = chip.getAttribute('data-filter');
    if (f && !(f in state)) state[f] = 'all';
  });
  var filterKeys = Object.keys(state).filter(function (k) { return k !== 'sort' && k !== 'page'; });
  var originalOrder = cards.slice();

  function setActiveChip(filter, value) {
    chips.forEach(function (c) {
      if (c.getAttribute('data-filter') === filter) {
        if (c.getAttribute('data-value') === value) c.classList.add('is-on');
        else c.classList.remove('is-on');
      }
    });
  }

  function getFiltered() {
    return cards.filter(function (card) {
      for (var i = 0; i < filterKeys.length; i++) {
        var k = filterKeys[i];
        if (state[k] !== 'all' && card.getAttribute('data-' + k) !== state[k]) return false;
      }
      return true;
    });
  }

  function sortCards(list) {
    var arr = list.slice();
    switch (state.sort) {
      case 'price-asc':
        arr.sort(function (a, b) { return parseFloat(a.dataset.price) - parseFloat(b.dataset.price); }); break;
      case 'price-desc':
        arr.sort(function (a, b) { return parseFloat(b.dataset.price) - parseFloat(a.dataset.price); }); break;
      case 'name':
        arr.sort(function (a, b) { return a.dataset.name.localeCompare(b.dataset.name); }); break;
      default:
        arr.sort(function (a, b) { return originalOrder.indexOf(a) - originalOrder.indexOf(b); }); break;
    }
    return arr;
  }

  function render() {
    var filtered = sortCards(getFiltered());
    var totalPages = Math.max(1, Math.ceil(filtered.length / PER_PAGE));
    if (state.page > totalPages) state.page = 1;
    var start = (state.page - 1) * PER_PAGE;
    var pageItems = filtered.slice(start, start + PER_PAGE);

    cards.forEach(function (c) { c.setAttribute('data-hidden', ''); });
    pageItems.forEach(function (c) { c.removeAttribute('data-hidden'); });
    pageItems.forEach(function (c, i) { c.style.order = i; });

    countShownEl.textContent = filtered.length;
    emptyEl.hidden = filtered.length !== 0;

    var anyActive = filterKeys.some(function (k) { return state[k] !== 'all'; });
    clearBtn.hidden = !anyActive;

    renderPagination(totalPages);
  }

  function renderPagination(totalPages) {
    paginationEl.innerHTML = '';
    if (totalPages <= 1) { paginationEl.hidden = true; return; }
    paginationEl.hidden = false;

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'co-page';
    prev.textContent = '← Prev';
    prev.disabled = state.page === 1;
    prev.addEventListener('click', function () { state.page--; render(); scrollTopOfGrid(); });
    paginationEl.appendChild(prev);

    for (var i = 1; i <= totalPages; i++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'co-page' + (i === state.page ? ' is-on' : '');
      b.textContent = String(i);
      (function (n) { b.addEventListener('click', function () { state.page = n; render(); scrollTopOfGrid(); }); })(i);
      paginationEl.appendChild(b);
    }

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'co-page';
    next.textContent = 'Next →';
    next.disabled = state.page === totalPages;
    next.addEventListener('click', function () { state.page++; render(); scrollTopOfGrid(); });
    paginationEl.appendChild(next);
  }

  function scrollTopOfGrid() {
    var top = grid.getBoundingClientRect().top + window.scrollY - 80;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      var filter = chip.getAttribute('data-filter');
      var value = chip.getAttribute('data-value');
      state[filter] = value;
      state.page = 1;
      setActiveChip(filter, value);
      render();
    });
  });

  sortSelect.addEventListener('change', function () {
    state.sort = sortSelect.value;
    state.page = 1;
    render();
  });

  clearBtn.addEventListener('click', function () {
    filterKeys.forEach(function (k) {
      state[k] = 'all';
      setActiveChip(k, 'all');
    });
    state.page = 1;
    render();
  });

  render();
})();
